// extracted by mini-css-extract-plugin
export var active = "_9g-7";
export var blink = "_9g-8";
export var dropDownSelector = "_9g-4";
export var dropDownWrapper = "_9g-3";
export var fakeCursor = "_9g-6";
export var fontSizeButton = "_9g-9";
export var formQuillEditor = "_9g-0";
export var pressed = "_9g-a";
export var qlBlank = "_9g-1";
export var textFormattingToolbar = "_9g-2";
export var textToolbarOption = "_9g-5";